import { WarningOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import React from 'react';

import s from './NoPreview.module.less';

interface NoPreviewProps {
  ext?: string;
  size?: number | string;
  badge?: boolean;
}

const NoPreview: React.FC<NoPreviewProps> = ({ ext, size = 60, badge }) => {
  const sizePx = typeof size === 'number' ? `${size}px` : size;

  return (
    <div
      className={clsx(s.noPreview, { [s.withBadge]: Boolean(badge) })}
      style={{ '--size': `${sizePx}` } as React.CSSProperties}
    >
      <WarningOutlined />
      <span>{ext ? `${ext.toUpperCase()} - no preview` : 'No preview'}</span>
    </div>
  );
};

export default NoPreview;
